import { createAPIModule } from 'utility/redux/apiModuleHelpers';
import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.network.dns.domain.transfer.delete;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_DOMAIN_TRANSFER_DELETE',
	method: 'POST',
	url: '/network/dns/domain/transfer/delete.json',
});

const selectors = {
	success: createSelector(defaultSelectors.getStateSlice, (slice) =>
		slice.getIn(['data', 'success']),
	),
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
